import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customerwelcome } from '../model/customerwelcome';

@Injectable({
  providedIn: 'root'
})
export class CustomerwelcomeeditService {

  constructor(private http:HttpClient) { }

  getWelcomeMessage(customerId: string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	/organization/{organizationId}/customerwelcome/{customerId}
    return this.http.get<Customerwelcome>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customerwelcome/'+customerId+'/pit/'+new Date().toISOString(),httpOptions);
  
  }

  saveWelcomeMessage(customerId: string, message: string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //PUT	/organization/{organizationId}/customerwelcome/{customerId}
    return this.http.put<string>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customerwelcome/'+customerId,message,httpOptions);
  
  }

}
